export const fetchPricing=fetch=>{return()=>{return fetch("/pricings/pricing")}};